import { Box, Stack, TextField } from "@mui/material";
import {
  DesktopDateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import StockHistoryTable from "pages/inventory/history_template/StockHistoryTable";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { dispatch } from "store";
import { getMainStockHistoryThunk } from "store/reducers/inventory/stock/mainStockSlice";

const MainStockHistory = () => {
  const { time } = useParams();
  const [filter, setFilter] = useState({
    time: time ? moment(time).add(1, 'second') : moment(),
  });


  useEffect(() => {
    dispatch(getMainStockHistoryThunk(filter.time.toISOString()));
  }, [filter.time]);
  const state = useSelector((state) => state.mainStock);
  return (
    <Box padding={2}>
      <Stack direction="row" justifyContent="center" spacing={1.5} marginY={2}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DesktopDateTimePicker
            label="Pick a date"
            value={filter.time}
            onChange={(value) => setFilter({ ...filter, time: value })}
            renderInput={(params) => (
              <TextField variant="outlined" {...params} />
            )}
          />
        </LocalizationProvider>
      </Stack>
      <StockHistoryTable items={state.history} />
    </Box>
  );
};

export default MainStockHistory;
